import { useContext } from "react";
import { useMutation } from "react-query";
import { ApiContext } from "../../contexts/ApiContext";
import { EnhancedCustomerSubmission } from "../../shared/interfaces/Customer";
import { QueryCallbacks } from "../../shared/interfaces/ReactQuery";

export function useEnhancedCustomerCreate(callbacks?: QueryCallbacks<number>) {
  const apiContext = useContext(ApiContext);

  return useMutation({
    ...callbacks,
    mutationKey: ["createEnhancedCustomer"],
    mutationFn: async (customer: EnhancedCustomerSubmission) =>
      apiContext.customerApis.createEnhancedCustomer(customer),
  });
}
